import AllProviders from './AllProviders';
import MainRoutes from '@/routes/MainRoutes';
import WhiteLabelProvider from './WhiteLabelProvider';
import { useAxiosWithToast } from '@/hooks/axiosInterceptor';
import { OrganizationHeadUpdater } from '@/App';
import FeatureBaseIntegration from '../components/Common/FeatureBaseIntegration';
import { useNewReleaseCheck } from '../hooks/useNewReleaseCheck';

const RootProvider = () => {
  const { ToastComponent } = useAxiosWithToast();
  useNewReleaseCheck();
  const domain = window.location.hostname;
  const isNextBrandDomain = domain.includes('auth-nb-connector.nextbrand');

  if (isNextBrandDomain) {
    return (
      <WhiteLabelProvider>
        <MainRoutes />
        {ToastComponent}
      </WhiteLabelProvider>
    );
  }

  return (
    <AllProviders>
      <OrganizationHeadUpdater />
      <MainRoutes />
      {ToastComponent}
      <FeatureBaseIntegration />
    </AllProviders>
  );
};

export default RootProvider;
